import React from "react";
import { Outlet } from "react-router";
import Navbar from "./Navbar";

const MaxLayout = () => {
  const showNavbar = process.env.REACT_APP_CLIENT !== "pixel";

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex flex-col relative overflow-x-hidden">
      <div className="fixed inset-0 z-0 pointer-events-none bg-[#121212]" />

      <div className="relative z-10 flex flex-col min-h-screen pt-1">
        {showNavbar && <Navbar />}
        <main className="flex-grow flex justify-center">
          <div className="relative w-full max-w-[375px] sm:max-w-2xl py-1">
            <div className="relative px-0 bg-transparent">
              <div className="w-full mx-auto">
                <div className="divide-y divide-border/0">
                  <div className="text-base leading-6 space-y-4 text-foreground sm:text-lg sm:leading-7">
                    <Outlet />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default MaxLayout;
